import React from 'react';
import {PageTitle} from './style';

const Heading = (props) => {
  return (
    <PageTitle>
      {props.title || props.children}
    </PageTitle>
  );
};

export default Heading;